@if(data()){
  @if (data().data.style === 'ordered') {
    <ol class="py-2 editor-list">
      @for (list of data().data.items; track list) {
        <li [innerHTML]="list"></li>
      }
    </ol>
  } @else {
    <ul class="py-2 editor-list">
      @for (list of data().data.items; track list) {
        <li [innerHTML]="list"></li>
      }
    </ul>
  }
}
